import { render, staticRenderFns } from "./dwkpyjlist.vue?vue&type=template&id=92dffa64&scoped=true"
import script from "./dwkpyjlist.vue?vue&type=script&lang=js"
export * from "./dwkpyjlist.vue?vue&type=script&lang=js"
import style0 from "./dwkpyjlist.vue?vue&type=style&index=0&id=92dffa64&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dffa64",
  null
  
)

export default component.exports